import { ReactElement } from 'react'

//----- Component -----//

export const YourbowBottomSticky = (): ReactElement => (
	<div className="ad-wrapper" id="div-bottom-ad"></div>
)
